import ChatMessageLocation  from './ChatMessageLocation';

export default ChatMessageLocation;
